import { Injectable } from '@angular/core';
import { BrowserStack } from 'protractor/built/driverProviders';

const EMPTY_DEPARTMENT_NAME = '';
const DESCENDING_SORT = 'descending';
const REVERSED_SORT_FIELDS = ['levels', 'dates'];
const SORT_FIELD_OPTION = 0;
const TOGGLE_SORT_OPTION = 1;
const FIRST_MATCH_INDEX = 0;

interface SortableRow {
  group?: {name?: string};
  description?: string;
  status?: string;
  name?: string;
  creationDate?: string;
  initiator?: {fullName: string};
  data?: {level?: string, date?: string};
}

function departmentName(row: SortableRow): string {
  return row && row.group && row.group.name || EMPTY_DEPARTMENT_NAME;
}

const SORT_VALUE: {[field: string]: (row: SortableRow) => string} = {
  department: departmentName,
  type: row => row.description,
  status: row => row.status,
  title: row => row.name,
  date: row => row.creationDate,
  initiator: row => row.initiator.fullName,
  levels: row => row.data.level,
  dates: row => row.data.date
};

@Injectable()
export class SortTableService {
  sortDetails = {
    allSuggestionListSort: {
      field: 'department',
      sortType: 'ascending',
    },
    allReviewSLList: {
      field: 'department',
      sortType: 'ascending',
    },
    myDraftsList: {
      field: 'department',
      sortType: 'ascending',
    },
    mySLList: {
      field: 'department',
      sortType: 'ascending',
    },
    allGroupList: {
      field: 'title',
      sortType: 'ascending',
    },
    myGroupList: {
      field: 'title',
      sortType: 'ascending'
    }
  };

  constructor() { }

  sortedTable(tableName, field) {
    this.sortDetails[tableName].field = field;
    return this.sortDetails[tableName].sortType === 'descending' ? 'ascending' : 'descending';
  }

  sortList = (tableName: string, list: SortableRow[], ...options: Array<string | boolean>): void => {
    if (options[TOGGLE_SORT_OPTION]) {
      this.sortDetails[tableName].sortType = this.sortedTable(tableName, options[SORT_FIELD_OPTION]);
    }
    const details = this.sortDetails[tableName];
    if (!Object.prototype.hasOwnProperty.call(SORT_VALUE, details.field)) { return; }
    const value = SORT_VALUE[details.field];
    const reversedField = REVERSED_SORT_FIELDS.indexOf(details.field) >= FIRST_MATCH_INDEX;
    const forward = (details.sortType === DESCENDING_SORT) !== reversedField;
    list.sort((left, right) => forward ? value(left).localeCompare(value(right)) : value(right).localeCompare(value(left)));
  }
}





// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/sort-table.service.ts